// extracted by mini-css-extract-plugin
export default {"container":"col_39RKo"};